import './styles/ModalFormatosVentas.css';
import { ModalBase } from "../../../../components/Modals/ModalBase";
import { useDispatch, useSelector } from "react-redux";
import { setCargarRetencionesVentas, ventasOpenModelCargarFormato } from "../../../../actions/libros/libros-ventas.actions";
import { generalShowLoader } from "../../../../actions/general.actions";
import { useState } from "react";
import * as XLSX from 'xlsx';
import { decodificarBinarioUtf8, validRowRetenciones } from "../../../../utils/cargas.utils";
import { State } from '../../../../reducers';

const optionsPlantillas = {
  retenciones: 'retenciones',
}

const optionsText: { [key in keyof typeof optionsPlantillas]: string } = {
  retenciones: 'Retenciones',
};

export default function ModalCargarFormatoVentas () {
  const dispatch = useDispatch();
  const {formVentas} = useSelector((state: State) => state.libros)

  const [selectPlantilla, setSelectPlantilla] = useState(optionsPlantillas.retenciones);
  const [fileName, setFileName] = useState('');
  const [dataFile, setDataFile] = useState([]);
  const [fileBase64, setFileBase64] = useState('');
  const [fileExt, setFileExt] = useState('');
  const [dataCustom, setDataCustom] = useState('');

  const [error, setError] = useState('');
  const [warnEmpty, setWarnEmpty] = useState('');

  const handleAccept = async () => {
    if (!error && !warnEmpty) {
      if (dataFile?.length > 0) {
        const extension = fileExt.replace(".", "");
        switch(selectPlantilla) {
          case optionsPlantillas.retenciones:
            if (await dispatch(setCargarRetencionesVentas(fileBase64, dataCustom, extension, formVentas))) {
              handleCloseModal();
            };
            break;

          default:
            break;
        }
      } else {
        setError('Por favor, cargar un archivo');
      }
    }
  }

  const handleCloseModal = () => {
    dispatch(ventasOpenModelCargarFormato(false));
  }

  const cleanEmptyData = (data: any, ext: string) => {
    // Filtrar los datos que no estén vacíos
    var resultCountCleaned:Array<any> = [];
    var countIndex = ext === ".xlsx" ? 2 : 1;
  
    // Verificar si alguna de las celdas de la fila está vacía
    var cleanedData = data.filter((row: any) => {
      var valid = false;
      switch (selectPlantilla) {
        case optionsPlantillas.retenciones:
          valid = validRowRetenciones(row, ext, formVentas);
          break;
      }

      if (!valid) {
        resultCountCleaned.push(countIndex);
      }

      countIndex++;
      return valid;
    });

    return [cleanedData, resultCountCleaned];
  };

  const onChangeFile = (e: any) => {
    try {
      dispatch(generalShowLoader(true));

      const selectedFile = e.target.files[0];

      if(selectedFile){
        const reader = new FileReader();
        reader.onload = (evt: any) => {
          const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf('.'));
          const validTypes = ['.xlsx', '.json'];
          
          if(!validTypes.includes(fileExtension.toLowerCase())){
            setError('Por favor, selecciona un archivo con una extensión válida. (.xlsx, .json)')
            return;
          }
          setFileName(selectedFile.name);
          setFileExt(fileExtension);

          var jsonData;
          try {
            // Inicio procesar informacion
            if (fileExtension === ".xlsx") {
              const bstr = evt.target.result;
              const wb = XLSX.read(bstr, {type:'binary'});
              const wsname = wb.SheetNames[0];
              const ws = wb.Sheets[wsname];
              jsonData = XLSX.utils.sheet_to_json(ws);
            } else if (fileExtension === ".json") {
              jsonData = JSON.parse(decodificarBinarioUtf8(evt.target.result));
              if (jsonData && !Array.isArray(jsonData)) {
                jsonData = [jsonData];
              }
            }
          } catch (parseError) {
            setError('El archivo cargado no tiene un formato válido, por favor validar archivo e intentar nuevamente.');
            return;
          }

          // Limpiar data
          const [dataClean, resultClean] = cleanEmptyData(jsonData, fileExtension);
          
          // Validaciones generales
          if (resultClean?.length > 0) {
            setWarnEmpty(`Alerta: Se detectaron en el documento ${resultClean.length} registros incorrectos. \nPor favor revisar el archivo de carga e intentar nuevamente. \nFilas con error: ${resultClean?.join(", ")}.`);
          } 
          else if (dataClean?.length === 0) {
            setWarnEmpty(`Alerta: No se detectaron registros en el documento. \nPor favor revisar el archivo de carga e intentar nuevamente.`);
          } 
          else {
            // Validaciones especificas
            var validacionExtra = true;
            if (selectPlantilla === optionsPlantillas.retenciones) {
              const serie = jsonData[0]?.["SERIE CCF"] ?? jsonData[0]?.cuerpoDocumento[0]?.numDocumento.substring(0, 8) ?? false;
              if (!serie && fileExtension === ".xlsx") {
                validacionExtra = false;
                setWarnEmpty(`Alerta: No se detecto la serie general en el documento cargado. \nPor favor revisar el archivo de carga e intentar nuevamente.`);
              }
              setDataCustom(`${serie}`);
            }

            if (validacionExtra) {
              setWarnEmpty('');
            }
          }
          
          // Guardar data
          setDataFile(dataClean);
          setFileBase64(btoa(evt.target.result));
          setError('');
        }
      
        reader.readAsBinaryString(selectedFile);
      } else {
        setFileName('');
        setFileExt('');
        setError('Por favor, seleccione un archivo');
      }
    } catch (error) {
      setError('Ocurrió un error al cargar el comprobante, Por favor revisar el archivo e intentar cargarlo nuevamente.');
    } finally {
      dispatch(generalShowLoader(false));
    }
  }

  const handleChangePlantilla = (e: any) => {
    setDataFile([]);
    setError('');
    setFileBase64('');
    setFileName('');
    setFileExt('');
    setSelectPlantilla(e.target.value);
    setWarnEmpty('');
  }

  return (
    <ModalBase>
      <div className="dte-send-email-container">
        <div>
          <h3 className="card-title">Cargar plantilla</h3>
        </div>
        <div className="separador"/>
        <h1 className="m" style={{ fontWeight: '400', margin: '0'}}>Aqui puedes cargar datos utilizando las plantillas disponibles:</h1>
        <div className='label-input'>
          <label htmlFor='tipoCarga' className='field-label m'>
            Tipo de carga
          </label>
          <select
            id='tipoCarga'
            name='tipoCarga'
            className='m text-field w-select'
            value={selectPlantilla}
            onChange={handleChangePlantilla}
          >
            {Object.entries(optionsPlantillas).map(([key, value]) => (
              <option key={key} value={value}>
                {optionsText[key as keyof typeof optionsPlantillas]}
              </option>
            ))}
          </select>
        </div>
        <div className='label-input'>
          <div className='file-input'>
            <input 
              autoComplete='off'
              type='file' 
              className='text-field w-input upload_file_input file-input' 
              name='retencionesexcel' 
              id='retencionesexcel' 
              accept=".xlsx, .json"
              onChange={onChangeFile}
            />
            <span className='m button'>Seleccionar archivo</span>
            <span className='label'>{fileName || 'Ningún archivo seleccionado'}</span>
          </div>
          {error && <p className='alert s'>{error}</p>} 
        </div>
        {warnEmpty && <p className='alert s'>{warnEmpty}</p>}
        <div className="dte-send-email-footer">
          <button className="button transparent w-inline-block" onClick={() => dispatch(ventasOpenModelCargarFormato(false))}>
            Cerrar
          </button>
          <button className="button w-inline-block" onClick={handleAccept}>
            Cargar
          </button>
        </div>
      </div>
    </ModalBase>
  )
}